/* 機能訓練レポート利用者選択 */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as AuthActions from '../actions/Auth';
import * as MoffAPIActions from '../actions/MoffAPI';
import * as HeaderActions from '../actions/Header';
import UserSelectLiterallyReport from '../components/UserSelectLiterallyReport';

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth,
    moffAPI: state.moffAPI,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    authActions: bindActionCreators(AuthActions, dispatch),
    moffAPIActions: bindActionCreators(MoffAPIActions, dispatch),
    headerActions: bindActionCreators(HeaderActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserSelectLiterallyReport as any);



// WEBPACK FOOTER //
// ./src/containers/UserSelectLiterallyReport.tsx